import React from "react";
import RadioChecked from "./RadioButtonCheckedFilled.svg";
import RadioUnchecked from "./RadioButtonUncheckedFilled.svg";

export default function Radio({ name, fullWidth = false, choices, form, setForm }) {
  const containerWidth = fullWidth ? { width: "100%" } : { maxWidth: 460 };
  const middleCellWidth = fullWidth ? { width: "80%" } : { maxWidth: 250 };
  const rightCellWidth = fullWidth ? { width: "20%" } : { maxWidth: 300 };
  function handleClick(id) {
    setForm({ ...form, [name]: id });
  }
  const error = form.errors !== null ? form.errors[name]?.reduce((n, m) => m, []) : null;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", ...containerWidth }}>
        {error && <div style={{ color: "red", margin: "1rem 0" }}>{error}</div>}
        {choices.map((n, idx) => (
          <div
            key={idx}
            style={{
              background: form[name] === n.id ? "#F4F2E6" : "",
              border: error && form[name] === n.id ? "1px solid red" : "1px solid #F4F2E6",
              borderRadius: "21px",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              marginBottom: "1rem",
              position: "relative"
            }}
            tabIndex="0"
            onClick={() => handleClick(n.id)}
            onKeyPress={(e) => (e.key === "Enter" ? handleClick(n.id) : null)}
          >
            <div
              style={{
                alignContent: "center",
                alignItems: "center",
                color: "#011F31",
                display: "flex",
                justifyContent: "space-evenly",
                letterSpacing: "0.25px",
                lineHeight: "20px",
                padding: "1.25rem"
              }}
            >
              <div style={{ fontSize: 24, marginRight: "1rem" }}>
                {form[name] === n.id ? <RadioChecked /> : <RadioUnchecked />}
              </div>
              <div style={{ flexGrow: 1, marginRight: ".5rem", ...middleCellWidth }}>
                <div style={{ textAlign: "left", fontFamily: "BentonSans", fontWeight: "700" }}>
                  {n.name}
                </div>
                <div style={{ textAlign: "left" }}>{n.description}</div>
              </div>
              <div style={{ ...rightCellWidth }}>{n.detail}</div>
            </div>
            {n.extra}
          </div>
        ))}
      </div>
    </div>
  );
}
